import { defineMessages } from 'react-intl'
import { useIntl } from 'react-intl'
import PoweredByHooplaIconUI from './PoweredByHooplaIconUI/PoweredByHooplaIconUI'
import type { FC } from 'react'

export type PoweredByHooplaIconProps = {
  /** Boolean indicating if the current theme is dark mode */
  isDarkMode: boolean
  isLibraryBrandingEnabled?: boolean
  libraryName?: string
  fromTopNav?: boolean
}

const messages = defineMessages({
  poweredByHoopla: {
    id: 'headerv2.nav.poweredByHoopla',
    defaultMessage: 'Powered by Hoopla',
  },
})

/**
 * Container component in container/presenter pattern. All logic should be handled
 * in this component, while the presenter component (`PoweredByHooplaIconUI`) should only handle how the
 * component looks.
 */
const PoweredByHooplaIcon: FC<PoweredByHooplaIconProps> = ({
  isDarkMode,
  isLibraryBrandingEnabled,
  libraryName,
  fromTopNav = false,
}) => {
  // Hooks
  const { formatMessage } = useIntl()
  if (!isLibraryBrandingEnabled) return <>{libraryName}</>

  const label = formatMessage(messages.poweredByHoopla)

  const hasDarkBackground = () => {
    if (isDarkMode || fromTopNav) return true
    return false
  }

  return (
    <PoweredByHooplaIconUI label={label} isDarkMode={hasDarkBackground()} />
  )
}

export default PoweredByHooplaIcon
